export class EnumApiProtect {}
